// The files in the platform agent's message box (D6, docs/platform-agent/contracts.md §8). The label, placeholder
// and hint stay in PlatformAgentConversation's `composer`.
export default {
  drop: "Sleep bestanden hierheen: PDF, foto's, Excel, CSV of Word",
  waiting: 'Verzenden wacht tot de bestanden zijn geüpload.',
  // A PDF's pages on its tile (B37): "PDF · 1.2 MB · 4 pages".
  pages_one: '{{count}} pagina',
  pages_other: "{{count}} pagina's",
  problems: {
    type: 'Dit bestandstype kan niet worden verzonden. Stuur een pdf, een foto (JPG, PNG of HEIC) of een Excel-, CSV- of Word-bestand.',
    size: 'Meer dan 20 MB. Een bestand mag maximaal 20 MB zijn.',
    empty: 'Dit bestand is leeg.',
    count: 'Maximaal 10 bestanden per bericht.',
    upload: 'De upload is gestopt. Probeer het opnieuw.',
  },
};
